/** AUTH MESSAGES */
export const INVALID_USER = "Invalid username or password. Please try again.";
export const INVALID_NEW_PASSWORD =
  "New password must be at least 8 characters long and must contain 1 uppercase, 1 lowercase, 1 number, and 1 special character.";

/** GENERIC MESSAGES */
export const GENERIC_ERROR = "Something went wrong. Please try again later.";
export const SAVED_SUCCESS = "Changes have been saved.";
